import {CalendarRegularPenIcon} from 'shells/icon/svg/calendar-regular-pen-icon';
import {ChatBubbleDoubleRegularIcon} from 'shells/icon/svg/chat-bubble-double-regular-icon';
import {ChatRegularIcon} from 'shells/icon/svg/chat-regular-icon';
import {EnvelopeNewIcon} from 'shells/icon/svg/envelope-new-icon';
import {PhoneOutlineIcon} from 'shells/icon/svg/phone-outline-icon';
import {QuoteRegularIcon} from 'shells/icon/svg/quote-regular-icon';

export type EngagementLeadType = 'chats' | 'bookings' | 'quotes' | 'texts' | 'calls' | 'emails';

export const ENGAGEMENT_LEAD_TYPES: EngagementLeadType[] = [
    'chats',
    'bookings',
    'quotes',
    'emails',
    'calls',
    'texts',
];

export const ENGAGEMENT_LEAD_CONFIG: Record<
    EngagementLeadType,
    {icon: React.ComponentType<any>; text: string}
> = {
    chats: {
        icon: ChatBubbleDoubleRegularIcon,
        text: 'Chat leads',
    },
    bookings: {
        icon: CalendarRegularPenIcon,
        text: 'Book leads',
    },
    quotes: {
        icon: QuoteRegularIcon,
        text: 'Quote leads',
    },
    texts: {
        icon: ChatRegularIcon,
        text: 'Text leads',
    },
    calls: {
        icon: PhoneOutlineIcon,
        text: 'Call leads',
    },
    emails: {
        icon: EnvelopeNewIcon,
        text: 'Email leads',
    },
} as const;
